/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCredentialsAvailabilityEntity
 */
export interface ClientCredentialsAvailabilityEntity {
    /**
     * 
     * @type {boolean}
     * @memberof ClientCredentialsAvailabilityEntity
     */
    available: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientCredentialsAvailabilityEntity
     */
    reason?: string;
}

/**
 * Check if a given object implements the ClientCredentialsAvailabilityEntity interface.
 */
export function instanceOfClientCredentialsAvailabilityEntity(value: object): value is ClientCredentialsAvailabilityEntity {
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function ClientCredentialsAvailabilityEntityFromJSON(json: any): ClientCredentialsAvailabilityEntity {
    return ClientCredentialsAvailabilityEntityFromJSONTyped(json, false);
}

export function ClientCredentialsAvailabilityEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCredentialsAvailabilityEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function ClientCredentialsAvailabilityEntityToJSON(json: any): ClientCredentialsAvailabilityEntity {
    return ClientCredentialsAvailabilityEntityToJSONTyped(json, false);
}

export function ClientCredentialsAvailabilityEntityToJSONTyped(value?: ClientCredentialsAvailabilityEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'reason': value['reason'],
    };
}

